"use client";

import type { ReactNode } from "react";
import { X } from "lucide-react";
import "./overlays.css";
import { useBreakpoint } from "@/hooks/use-mobile-layout";
import { useMobileBackLayer } from "@/studio/components/MobileBackStackHost";

/** Side drawer on desktop. Bottom sheet on mobile, with peek and full. */
export function StudioSheet({
  open,
  onClose,
  title,
  children,
  snap = "full",
  bare = false,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  snap?: "peek" | "full";
  /** Caller draws its own head. The sheet still owns the scrim and the panel. */
  bare?: boolean;
}) {
  const { isMobile } = useBreakpoint();
  useMobileBackLayer(`sheet:${title}`, open, onClose);
  if (!open) return null;

  return (
    <div className="studio-overlay-backdrop" data-studio-overlay="" onClick={onClose}>
      <aside
        role="dialog"
        aria-label={title}
        className={`studio-overlay-panel${isMobile ? " is-bottom" : " is-side"}${snap === "peek" ? " is-peek" : ""}`}
        onClick={(event) => event.stopPropagation()}
      >
        {bare ? null : (
          <header className="studio-overlay-panel-head">
            <span>{title}</span>
            <button
              type="button"
              className="cursor-icon-btn studio-chrome-icon-btn studio-head-circle-btn"
              aria-label="Close"
              title="Close"
              onClick={onClose}
            >
              <X aria-hidden="true" />
            </button>
          </header>
        )}
        <div className="studio-overlay-panel-body">{children}</div>
      </aside>
    </div>
  );
}
